<div class="modal-dialog modal-login">
    <div class="modal-content">
        <div class="modal-header">		
            <h5 class="modal-title">{{ 'SHARED.WELCOME' | translate }}</h5>
            <img class="img-fluid height-35p" src="../../../assets/eurobitLogoOnBlack.png">
        </div>

        <p class="login-subtitle" [@inOutAnimation] >{{  'USERS.PASSWORD_FORGOT' | translate }}</p>
        <div class="modal-body pt-0">
            <form [formGroup]="formData" (ngSubmit)="onSubmit()">
                <div class="form-group mt-1">
                    <i class="fa fa-lock"></i>
                    <input type="password" class="form-control" formControlName="newPassword" [placeholder]="'PASSWORD.NEW_PASSWORD' | translate">					
                </div>
                <div class="form-group mt-1">
                    <i class="fa fa-lock"></i>
                    <input type="password" class="form-control" formControlName="repeatPassword" [placeholder]="'PASSWORD.REPEAT_PASSWORD' | translate">					
                </div>
                
                <div class="form-group mt-1">
                    <button type="submit" [disabled]="formData.invalid" class="btn btn-transparent btn-block btn-lg">
                        {{ 'REGISTRATIONS.BUTTONS.APPROVE' | translate }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
